module.exports = __webpack_public_path__ + "img/3Dmeishushi.f80eabc0.png";